let items = [
    {
        text: "businessLoans",
        link: "/business-loans",
    },
    {
        text: "myCustomers",
        link: "/customers",
    },
    {
        text: "transactions",
        link: "/transactions",
    },
    {
        text: "invoices",
        subItems: [
            {
                text: "account",
                link: "/ledger",
            },
            {
                text: "payments",
                link: "/payments",
            },
            {
                text: "fullyPaid",
                link: "/invoices-payed",
            },
            {
                text: "credit",
                link: "/invoices-credit",
            },
            {
                text: "deducted",
                link: "/invoices-deducted",
            },
            {
                text: "historicalLedger",
                link: "/historical-ledger",
            },
        ],
    },
    {
        text: "deposits",
        link: "/depositions",
    },
    {
        text: "myDebt",
        link: "/invoices-receivables",
    },
    {
        text: "myPrice",
        link: "/price",
        shouldRender: (brand, service) =>
            brand !== "FinanceLink" && service === 4,
    },
        {
        externalUrl: true,
        text: "teelasku",
        link: "https://www.financelink.fi/teelasku.fi",
        shouldRender: (brand) =>
            brand === "FinanceLink"
    },
];

export const getMenuItems = (brand, serviceId) => {
    if (typeof brand === "undefined" || typeof serviceId === "undefined")
        return [];

    const filterdItems = items.filter((item) => {
        if (typeof item.shouldRender === "function") {
            return item.shouldRender(brand, serviceId);
        }
        return true;
    });

    return filterdItems;
};
